import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-refer-dialog',
  templateUrl: './refer-dialog.component.html',
  styleUrls: ['./refer-dialog.component.scss']
})
export class ReferDialogComponent implements OnInit {
  canShare = false;
  referralCode: string;

  constructor(
    private clipboard: Clipboard,
    private authService: AuthService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<ReferDialogComponent>,
  ) {
    if (navigator.share) {
      this.canShare = true;
    }
  }

  async ngOnInit() {
    this.referralCode = await this.authService.getUserReferralCode();
  }

  get referralLink() {
    return `${environment.uiDomain}/session/sign-up?referralCode=${this.referralCode}`;
  }

  copyCode() {
    this.clipboard.copy(this.referralCode);
    this.notificationService.showInfo('Code copied to clipboard');
  }

  copyLink() {
    this.clipboard.copy(this.referralLink);
    this.notificationService.showInfo('Link copied to clipboard');
  }

  shareLink() {
    navigator.share({
      title: 'Share PaveHQ referral link',
      url: this.referralLink
    }).then(() => this.dialogRef.close());
  }
}
